import React, { useEffect } from "react"
import { i18n } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import {
  PRESS_LANDING_URL,
  cartDataUrl,
  footerUrl,
  headerUrl,
  previewContentPrefix,
} from "@/constants"
import AemGrid from "@/components/AemGrid"
import { getDataLayerObj, filterBackEndJson, getClienIP } from "@/utils/helper"
import { aemAxiosInstance, aemPreviewAxiosInstance } from "@/constants/api"

import GlobalPageHeader from "@/components/Shared/GlobalPage/GlobalPageHeader"
import GlobalPageFooter from "@/components/Shared/GlobalPage/GlobalPageFooter"
import {
  setDatalayerPageName,
  setGbhDataLayerCustom,
} from "@/store/features/genericSlice"
import { useDispatch } from "react-redux"
import PressLanding from "@/components/PressRoomLanding/v1/PressRoomLanding"
const PressRoom = ({
  tmpData: data,
  headertmp: header,
  footertmp: footer,
  ip,
  globalScript,
  footerScript,
  analyticsData,
  datalayerPageName,
  gbhDataLayerCustom,
}) => {
  useEffect(() => {
    getDataLayerObj(analyticsData)
  }, [analyticsData])

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setDatalayerPageName(datalayerPageName))
    dispatch(setGbhDataLayerCustom(gbhDataLayerCustom))
    return () => {
      dispatch(setDatalayerPageName(""))
      dispatch(setGbhDataLayerCustom(""))
    }
  }, [])

  return (
    <>
      <GlobalPageHeader
        header={header}
        title={data.title}
        globalScripting={globalScript}
      />
      <AemGrid
        data={data}
        count={0}
        pressReleaseLanding={data => <PressLanding data={data} />}
      />

      <GlobalPageFooter footer={footer} footerScripting={footerScript} />
    </>
  )
}

/**
 * Get ServerSideProps together.
 * @param {Object} request The first number.
 * @return {object} The props.
 */
export async function getServerSideProps({ req, locale }) {
  await i18n?.reloadResources()
  const isPreviewMode = req.cookies["aem-author-preview-mode"]
  const ip = getClienIP(req)

  const { data } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: previewContentPrefix + cartDataUrl,
        method: "GET",
      })
    : await aemAxiosInstance({
        url: PRESS_LANDING_URL,
        method: "GET",
      })
  const { data: header } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })
    : await aemAxiosInstance({
        url: `${data.headerExpFrg ? data.headerExpFrg : headerUrl}.model.json`,
        method: "GET",
      })

  const { data: footer } = isPreviewMode
    ? await aemPreviewAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
    : await aemAxiosInstance({
        url: `${data.footerExpFrg ? data.footerExpFrg : footerUrl}.model.json`,
        method: "GET",
      })
  const globalScript = data?.globalScript
  const footerScript = data?.footerScript
  const topHeadScript = data?.topHeadScript ? data?.topHeadScript : null
  const gbhDataLayerCustom = {}
  if (data?.datalayerPageName) {
    gbhDataLayerCustom.datalayerPageName = data?.datalayerPageName
  }
  if (data?.eventPageType) {
    gbhDataLayerCustom.eventPageType = data?.eventPageType
  }
  if (data?.pageType) {
    gbhDataLayerCustom.pageType = data?.pageType
  }
  let tmpData = {}
  if (data.pageComponentProperties) {
    tmpData = data.pageComponentProperties
  } else {
    tmpData = data
  }
  tmpData = filterBackEndJson(tmpData)
  const headertmp = filterBackEndJson(header)
  const footertmp = filterBackEndJson(footer)
  const analyticsData = data?.data ?? null
  const datalayerPageName = data?.datalayerPageName
  return {
    props: {
      ip,
      tmpData,
      headertmp,
      footertmp,
      globalScript,
      footerScript,
      topHeadScript,
      analyticsData,
      datalayerPageName,
      gbhDataLayerCustom,
      ...(await serverSideTranslations(locale, ["common"])),
    },
  }
}

export default PressRoom
